module.exports = __webpack_public_path__ + "static/img/6.2398279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/6.png
// module id = 2qQS
// module chunks = 0